import React from 'react';

function FBMessengerIcon({ w, h, style, className }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={w}
      height={h}
      style={style}
      viewBox="0 0 36 36"
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#3884F7" cx="18" cy="18" r="18" />
        <path
          d="M18.05 7.49C11.95 7.49 7 12.12 7 17.826c0 3.247 1.6 6.144 4.106 8.038v3.955l3.77-2.092c1.006.282 2.072.433 3.175.433 6.104 0 11.052-4.628 11.052-10.335 0-5.707-4.948-10.334-11.05-10.334zm1.165 13.86l-2.858-2.97-5.505 3.043 6.035-6.404 2.858 2.97 5.505-3.045-6.035 6.404z"
          fillRule="nonzero"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

FBMessengerIcon.defaultProps = {
  w: 36,
  h: 36,
};

export default FBMessengerIcon;
